﻿export const InitialiseSearchLogTable = (searchTerm) => {
  const hidGetSearchLogList = document.getElementById("hidGetSearchLogList");
  $("#SearchLogTable").dataTable({
    destroy: true,
    paging: true,
    pageLength: 20,
    searching: false,
    autoWidth: true,
    bLengthChange: false,
    processing: true,
    serverSide: true,
    ajax: {
      url: hidGetSearchLogList.value.toString(),
      dataType: "json",
      type: "POST",
      data: {
        searchTerm: searchTerm,
      },
    },
    order: [[1, "desc"]],
    columnDefs: [
      { title: "Contact", name: "Contact", targets: 0 },
      { title: "Activity Date", name: "ActivityDate", targets: 1 },
      { title: "Activity Type", name: "ActivityType", targets: 2 },
      { title: "Note", name: "Note", targets: 3 },
      { title: "UserName", name: "UserName", targets: 4 },
      { title: "", targets: 5, orderable: false },
    ],
    columns: [
      { data: "Contact" },
      {
        data: "ActivityDate",
        type: "date",
        render: function (data, type, row) {
          if (type === "display" || type === "filter") {
            if (data != null && data !== "") {
              const isoDate = data;
              return moment(isoDate).format("DD/MM/YYYY");
            } else {
              return "Not recorded";
            }
          }
          return data;
        },
      },
      { data: "ActivityType" },
      {
        data: "Note",
        fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
          if (oData.ID != null && oData.ID !== "") {
            if (oData.Note.length > 40) {
              $(nTd).html(
                "<p  data-bs-toggle='tooltip' id='" +
                  oData.ID +
                  "' class='whitespace-nowrap btnViewFullLog'>" +
                  oData.Note.substr(0, 38) +
                  "...</a>"
              );
            } else {
              $(nTd).html(
                "<p  data-bs-toggle='tooltip' class='whitespace-nowrap'>" +
                  oData.Note +
                  "</a>"
              );
            }
          }
        },
      },
      { data: "UserName" },
      {
        data: "ID",
        fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
          if (oData.ID != null && oData.ID !== "") {
            $(nTd).html(
              "<a href='" +
                $("#hidViewLog").val() +
                "/" +
                oData.ID +
                "' class='btn btn-success'>View</a>"
            );
          }
        },
      },
    ],
  });
  // $.ajax({
  // 	url: hidGetSearchLogList.value.toString(),
  // 	dataType: 'json',
  // 	type: 'POST',
  // 	data: {
  // 		searchTerm: searchTerm
  // 	},
  // 	success: function(data) {
  // 		const table = $('#SearchLogTable tbody')
  // 		$('#SearchLogTable tbody tr').remove()
  // 		table.innerHTML = ''
  // 		$.each(data, function (idx, elem) {
  // 			$.each(elem, function (idx, val) {
  // 				table.append('<tr><td>' + val.contact + '</td><td>' + val.activityDate + '</td><td>' + val.activityType + '</td><td>' + val.note + '</td><td>' + val.Username + '</td></tr>')
  // 			})
  // 		})
  // 	}
  // })
  // $('#SearchLogTable').dataTable({
  // 	destroy: true,
  // 	paging: true,
  // 	pageLength: 20,
  // 	searching: false,
  // 	autoWidth: true,
  // 	bLengthChange: false
  // })
};
